import React, { useEffect, useRef } from 'react';
import { ThemeContext } from '../theme/Theme.jsx';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface ErrorProps {
	message: string,
	margin: boolean,
	noPadding?: boolean,
	index: number,
	elementIdToLink?: string,
}

function Error(props: ErrorProps) {
	const context = React.useContext(ThemeContext);
	const style: any = {
		color: context.themeManager.valueOrDefault('errors', 'color', 'color-error', '#e10101'),
		marginBottom: '2em',
		padding: '1.8em 2.5em',
		fontSize: '1em',
		background: context.themeManager.value('errors', 'background', 'bg-color-box'),
		display: 'flex',
		alignItems: 'center',
		width: '100%',
	};
	
	if (props.noPadding) {
		delete style.padding;
	}
	
	const iconStyle = {
		fontSize: '1.7em',
		marginRight: '0.3em',
	};
	
	const btnRef = useRef<HTMLButtonElement>(null);
	
	useEffect(() => {
		btnRef?.current?.focus();
	}, []);
	
	function scrollToElement(id: string | undefined) {
		if (id) {
			const element = document.getElementById(id);
			const firstElementWithError: HTMLElement | null =
				document.querySelector('#' + id + ' [aria-invalid="true"]') || document.querySelector('#' + id + '[aria-invalid="true"]')
			if (element) {
				element.scrollIntoView({behavior: 'smooth'})
				firstElementWithError?.focus()
			}
		}
	}
	
	return (
		<button
			id={'link_' + props.elementIdToLink}
			className={'leo__button-sample'}
			style={style}
			{...(props.index === 0 ? {ref: btnRef} : {})} tabIndex={0}
			{...(props.elementIdToLink ? {
				'onClick': () => scrollToElement(props.elementIdToLink),
				'aria-label': 'Link zu Bereich mit dem Fehler: ' + props.message
			} : {})}>
			<FontAwesomeIcon
				icon="exclamation-circle"
				style={iconStyle}
			/>
			<span>{props.message}</span>
		</button>
	
	);
}

export default Error;
